"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPresentationOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.presentation_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "presentation_outline_svg__transparent_box" },
            React.createElement("path", { className: "presentation_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "presentation_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "presentation_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M28 21V3H17V1h-2v2H4v18h11v7h-4v2h10v-2h-4v-7zM6 5h20v14H6z" }),
            React.createElement("path", { d: "M10 12h2v4h-2zM15 9h2v7h-2zM20 11h2v5h-2z" }))));
}
exports.default = SvgPresentationOutline;
//# sourceMappingURL=PresentationOutline.js.map